module.exports = __webpack_public_path__ + "static/img_5002-cd2678a1796ef486513e41e07f15597c.webp";